import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/finance/FinanceClient.tsx");
